import {
  roles,
  ROLE_ADMIN,
  ROLE_CREATOR,
  ROLE_GUEST,
  ROLE_PUBLISHER
} from '../../../config/roles';
import * as PropTypes from 'prop-types';
import { useTranslate } from '@tolgee/react';

interface RoleIndicatorProps {
  role?: number;
  isOwner: boolean;
}

const RoleIndicator: React.FC<RoleIndicatorProps> = ({
  role,
  isOwner = false
}) => {
  const styles = {
    [ROLE_ADMIN]: ' badge-light-primary',
    [ROLE_CREATOR]: ' badge-light-success ',
    [ROLE_PUBLISHER]: ' badge-light-warning',
    [ROLE_GUEST]: ' badge-light-info'
  };
  const { t } = useTranslate();
  if (isOwner) {
    return (
      <div className={`badge py-3 px-4 fs-7 badge-light-dark`}>
        {t(`config.roles.owner`)}
      </div>
    );
  }
  if (role === undefined || role == null) return <></>;

  return (
    <div
      className={`badge py-3 px-4 fs-7 ${styles[role as keyof typeof styles]}`}
    >
      {t(`config.roles.${roles[role as keyof typeof roles]}`)}
    </div>
  );
};

export default RoleIndicator;
RoleIndicator.propTypes = {
  role: PropTypes.number,
  isOwner: PropTypes.bool
};
